export default {
  'app.actions.enter': 'Enter',
  'app.actions.back': 'Back',
  'app.actions.download': 'Download PDF',

  'app.home.header': 'Futurecom 2018 Floorplan',
  'app.home.paragraph': 'Lorem ipsum sit a merd dolor inpregnantis.',

  'app.header.reset': 'Reset Password',
  'app.header.createPassword': 'Create new password',

  'app.error': 'Error',
  'app.error.token': 'The link is wrong or has expired.',
  'app.success.reset': 'The new password has been changed successfully.',

  'app.label.name': 'Name',
  'app.label.email': 'Email',
  'app.label.password': 'New password',
  'app.label.confirmation': 'Confirm the new password',
};



/** WEBPACK FOOTER **
 ** ./src/app/intl/en.js
 **/